import { useLogStore } from '@/stores/logStore';
import { Button } from '@/components/ui/button';
import { Trash2, AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';

interface LogsViewerProps {
  workflowId?: string;
}

export function LogsViewer({ workflowId }: LogsViewerProps) {
  const { logs, clearLogs, getLogs } = useLogStore();
  const displayLogs = workflowId ? getLogs(workflowId) : logs;

  const levelIcons = {
    info: <Info className="w-4 h-4 text-blue-600" />,
    success: <CheckCircle className="w-4 h-4 text-green-600" />,
    error: <AlertCircle className="w-4 h-4 text-destructive" />,
    warning: <AlertTriangle className="w-4 h-4 text-amber-600" />,
  };

  const levelColors = {
    info: 'text-blue-600',
    success: 'text-green-600',
    error: 'text-destructive',
    warning: 'text-amber-600',
  };

  return (
    <div className="space-y-2">
      {displayLogs.length === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-4">
          No logs yet
        </p>
      ) : (
        <div className="space-y-1 max-h-64 overflow-y-auto">
          {displayLogs.map((log) => (
            <div
              key={log.id}
              className="flex gap-2 text-xs p-2 rounded bg-muted/30 hover:bg-muted/50 transition-colors"
            >
              {levelIcons[log.level]}
              <div className="flex-1 min-w-0">
                <p className={`font-mono truncate ${levelColors[log.level]}`}>
                  {log.message}
                </p>
                <p className="text-muted-foreground text-xs">
                  {log.timestamp.toLocaleTimeString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
      {displayLogs.length > 0 && (
        <Button
          variant="ghost"
          size="sm"
          className="w-full text-xs"
          onClick={() => clearLogs()}
        >
          <Trash2 className="w-3 h-3 mr-1" />
          Clear Logs
        </Button>
      )}
    </div>
  );
}
